import { IonContent, IonPage, IonRow } from '@ionic/react';
import React, { useEffect, useState } from 'react';
import { Link, useParams, useHistory } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
// swiper bundle styles
import 'swiper/swiper-bundle.min.css';
// swiper core styles
import 'swiper/swiper.min.css';
import ProcessGoalCard from '../../components/Cards/ProcessGoalCard';
import SearchBar from '../../components/SearchBar';
import { Folder } from '../../models/Folder';
import { FolderItem } from '../../models/FolderItem';
import DAService from '../../services/DAService.service';
import LocalStorage from '../../utils/LocalStorage';
import StyleHelper from '../../utils/StyleHelper';
import './TopicPage.scss';

export default function TopicPage(props: {
  screenSize: number;
}) {
  const { screenSize } = props;
  const [topicPerView, setTopicPerView] = useState<number>(0);
  const [goalsPerView, setGoalsPerView] = useState<number>(0);
  const [folderItem, setFolderItem] = useState<FolderItem | null>();
  const [selectedTopicId, setSelectedTopicId] = useState<string>('');
  const params: { parent: string, child: string, index: string } = useParams();
  const topicIndex = (Number(LocalStorage.get('topicIndex')) - 1);
  const [paddingStyle, setPaddingStyle] = useState('');
  const [toMappedData, setToMappedData] = useState([]);
  const [isProcessGoal, setIsProcessGoal] = useState<boolean>(false);
  const history = useHistory();
  let trueIndex = 0;

  // handles data to render
  useEffect(() => {
    setFolderItem(DAService.getFolderItemByFolderItemId(params?.parent, params?.child));
    setSelectedTopicId(params?.child);
  }, [params.parent, params.child]);
  // handles slides per view and rerender swiperslide
  useEffect(() => {
    setPaddingStyle('padding-xs');
    if (screenSize < 500) {
      setTopicPerView(3);
      setGoalsPerView(1.5);
    } else if (screenSize < 550) {
      setTopicPerView(3);
      setGoalsPerView(2);
    } else if (screenSize < 600) {
      setTopicPerView(3);
      setGoalsPerView(2);
    } else if (screenSize < 700) {
      setTopicPerView(4);
      setGoalsPerView(2);
    } else if (screenSize < 800) {
      setTopicPerView(4);
      setGoalsPerView(3.2);
    } else if (screenSize < 1400) {
      setTopicPerView(6);
      setGoalsPerView(3.5);
    } else {
      setTopicPerView(6);
      setGoalsPerView(5);
    }
  }, [screenSize, topicIndex, selectedTopicId]);

  useEffect(() => {
    // handle options data to render
    if (folderItem?.folderItems) {
      setIsProcessGoal(true);
      setToMappedData(folderItem.folderItems);
    } else {
      setIsProcessGoal(false);
    }
  });

  const handleNavigation = (folderItemId: string, itemId: string, topicPageIndex: number) => () => {
    if (topicPageIndex > 4) {
      history.push(`/goals/${itemId}/`);
    } else {
      setFolderItem(DAService.getFolderItemByFolderItemId(folderItemId, itemId));
      setSelectedTopicId(itemId);
      // change url without reloading/navigating
      window.history.replaceState(null, '', `/topics/${folderItemId}/${itemId}`);
    }
    // update local storage topic index
    LocalStorage.set('topicIndex', topicPageIndex);
  };

  return (
    <IonPage>
      <IonContent>
        <div style={{ background: '#501AA6', padding: '26px 16px 0px 16px' }}>
          <SearchBar data={{ name: '' }} hasNavigation />
          <div>
            <div
              style={{
                color: '#FFFFFF',
                fontSize: '18px',
                lineHeight: '24px',
                fontWeight: '600',
                fontFamily: 'AgrandirBold',
                padding: '11px 0px 10px 0px',
              }}
            >
              {folderItem && (`${folderItem.name} Phase`)}
            </div>
          </div>
        </div>
        <div className={paddingStyle}>
          <Swiper
            key={topicIndex}
            className="swiper-topic-page"
            slidesPerView={topicPerView}
            observeParents
            observer
            initialSlide={topicIndex}
          >
            {
              DAService.getFolders().map((folder: Folder) => (
                folder.folderItems && folder.folderItems.map((topic) => {
                  trueIndex += 1;
                  return (
                    <SwiperSlide key={`slider-${topic.itemId}`} onClick={handleNavigation(folder.itemId, topic.itemId, trueIndex)}>
                      <IonRow style={{
                        display: 'flex',
                        justifyContent: 'center',
                        width: '120px',
                      }}
                      >
                        <div
                          className="topic-phase"
                          style={(selectedTopicId === topic.itemId) ? { fontWeight: '900', borderBottom: '4px solid #4F17A8' } : { fontWeight: '400' }}
                        >
                          {topic.name}
                        </div>
                      </IonRow>
                    </SwiperSlide>
                  );
                })
              ))
            }
          </Swiper>
          <div style={{
            marginTop: '8px',
          }}
          >
            <div
              style={{
                fontFamily: 'AgrandirRegular',
                fontSize: '24px',
                lineHeight: '30px',
                letterSpacing: '1px',
                color: '#1F1F1F',
                padding: '12px 0px',
              }}
              data-testid="topic-page"
            >
              Overview
            </div>
            {/* eslint-disable-next-line  */}
            <div dangerouslySetInnerHTML={{ __html: folderItem?.description || '' }} />
          </div>
        </div>
        {isProcessGoal && (
          <div className={paddingStyle} style={{ background: '#501AA6' }}>
            <div className="section-label">
              {folderItem && (`${folderItem.name} Process Goals`)}
            </div>
            <Swiper
              slidesPerView={goalsPerView}
              observeParents
              observer
              initialSlide={0}
            >
              {
                toMappedData.map((goal: FolderItem, index: number) => (
                  <SwiperSlide key={goal.itemId}>
                    <Link
                      style={{ textDecoration: 'none' }}
                      to={`/goals/${goal.itemId}`}
                      type="button"
                      key={`button-${goal.itemId}`}
                    >
                      <ProcessGoalCard goal={goal} gradient={StyleHelper.getGradient(index)} isTopicPage />
                    </Link>

                  </SwiperSlide>
                ))
              }
            </Swiper>
          </div>
        )}
      </IonContent>
    </IonPage>
  );
}
